import { useContext } from 'react';

import { QueryDataContext } from './QueryDataContext';

/**
 * Hook to access query data context
 *
 * @throws Error if used outside QueryDataProvider
 */
export function useQueryData() {
  const context = useContext(QueryDataContext);
  if (!context) {
    throw new Error('useQueryData must be used within QueryDataProvider');
  }
  return context;
}

/**
 * Optional hook for components that might not have context
 */
export function useQueryDataOptional() {
  return useContext(QueryDataContext);
}
